import React, { useState,useContext, useEffect } from "react";
import { TextField, Button, Divider,MenuItem } from "@mui/material";
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import { toast } from "react-toastify";
import SoundAlert from "../../../../../../routes/SoundAlert";
import { Putrequest } from "../../../../../../context/AxiosRequest";
import { ContextData } from "../../../../../../context/Context";


const LoanRequestInfo = ({formData}) => {


  const {UserTokens,ReloadBioForms,setReloadBioForms} = useContext(ContextData)
  const [formDatas, setFormData] = useState({

    loanAmount: "",
    loanAmountWords:  "",
    tenor:  "",
    netMonthlyIncome: "",
    netMonthlyIncomeWords: "",
    loanCategory:   "",
    fieldName: "",
    program_type: "",

  });




 


  const [loadingField, setLoadingField] = useState("");

  const validateField = (name,value) => {

       
    switch (name) {

      
      case "loanAmount":

      case "netMonthlyIncome":
           Number(value)
        if (!value.trim()) return "This field cannot be empty";
       // if (!/^\d+$/.test(value)) return "Only numbers are allowed";

        break;

       case "tenor":
             {
          const s = value == null ? "" : String(value);
          if (s.trim() === "") return "This field cannot be empty";
          if (!/^\d+$/.test(s)) return "Only numbers are allowed";
          const num = Number(s);

           
                  if(formData.loanrequest.loanCategory === "studentloan"){

                           if (Number.isNaN(num) || num < 1 || num > 10)
    
                             return "Tenor must be between 1 and 10 years";

                  }else{

                         if (Number.isNaN(num) || num < 1 || num > 5)
                        
                         
                          return "Tenor must be between 1 and 5 years";

                  }
         


              }

        break;

      case "loanAmountWords":
      case "netMonthlyIncomeWords":
      case "program_type":

       if (!value.trim()) return "This field cannot be empty";

        break;
        default:
        break;


    }

    return  "";


  };

  const handleChange = (e) => {

    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
   

  };


  const handleSave = async (fieldName) => {

    const value = formDatas[fieldName];
    const error = validateField(fieldName, value);

    if (error) {
      toast.error(error);
      SoundAlert("error");
      return;
    }

    

    try {

      setLoadingField(fieldName);
     
        const response = await Putrequest("auth/update_loan_request",{...formDatas,fieldName,user_token:UserTokens})
   
               
                   if(response.status){

                    SoundAlert("success")
                    toast.success(response.textStatus)
                    setReloadBioForms(!ReloadBioForms)

                      }else{

                          SoundAlert("error")
                         toast.error(response.textStatus)
                         setReloadBioForms(!ReloadBioForms)
   

                      }
                  

     

    } catch (err) {

      toast.error("Failed to save. Please try again.");
      SoundAlert("error");

    } finally {

      setLoadingField("");

    }


  };


useEffect(()=>{

       setFormData({
    loanAmount: formData.loanrequest.loanAmount || "",
    loanAmountWords: formData.loanrequest.loanAmountWords || "",
    tenor: formData.loanrequest.tenor || "",
    netMonthlyIncome: formData.loanrequest.netMonthlyIncome || "",
    netMonthlyIncomeWords: formData.loanrequest.netMonthlyIncomeWords || "",
    loanCategory:  formData.loanrequest.loanCategory || "",
    program_type:  formData.loanrequest.program_type || ""

       })

  
  
  
},[formData])




  return (
    <div className="py-5">
      
      <h2 className="text-xl font-bold mb-4 text-gray-700">
        Loan Request Information
      </h2>
        {
          /* Loan Category Dropdown */
              
        

        } 
        
         <div className="mb-4">
              
            <TextField
                  select
                  label="Loan Category"
                  name="loanCategory"
                  value={formDatas.loanCategory}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  required
                  InputProps={{
                    endAdornment: (
                      <Button variant="outlined" color="secondary" onClick={() => handleSave("loanCategory")}>
                        Save
                      </Button>
                    ),
                  }}
                >
                
                 
                  <MenuItem value="studentloan">STUDENT TERTIARY EDUCATION LOAN</MenuItem>
                  <MenuItem value="thirdparty">STUDENT TERTIARY EDUCATION LOAN ( Third-Party Guarantee )</MenuItem>
                </TextField>
         </div>


         
         {
            formData.loanCategory === "thirdparty" && (
          <div className="mt-4 mb-4">
            {/* Third Part */}
          <h1 className="text-lg font-semibold mb-2 text-gray-600">Third Part Loan</h1>
          <p>
            Loan: A loan provided by an external financial institution or lender, not directly by the primary organization or company.
          </p>

          </div>
            )
          }


          {     
          formData.loanCategory === "studentloan" && (
           <div className="mt-4 mb-4">
           
             <h1 className="text-lg font-semibold mb-2 text-gray-600">Third Part Loan</h1>

             <p>
            Student Loan: A loan specifically designed to help students cover the costs of their education, including tuition, books, and living expenses.
             and is typically offered with lower interest rates and more flexible repayment terms compared to other types of loans.
            </p>

          </div>
          )
          
            }

       


         
      <div className="grid md:grid-cols-2 gap-6">
        {/* Loan Amount */}
        <div>
           
        <NumericFormat
        value={formDatas.loanAmount}
        onChange={handleChange}
        customInput={TextField}
        thousandSeparator
        name="loanAmount"
        valueIsNumericString
        prefix="₦"
        variant="outlined"
        label="Loan Amount (₦)"
        fullWidth
        inputProps={{ maxLength: 15, inputMode: "numeric" }}
          />
         {/*  <TextField
            fullWidth
            label="Loan Amount (₦)"
            name="loanAmount"
            value={formDatas.loanAmount}
            onChange={handleChange}
            inputProps={{ maxLength: 15, inputMode: "numeric" }}
          /> */}
          <Button
            variant="outlined"
            size="small"
            sx={{ mt: 1 }}
            disabled={loadingField === "loanAmount"}
            onClick={() => handleSave("loanAmount")}
          >
            {loadingField === "loanAmount" ? "Saving..." : "Save"}
          </Button>
        </div>

        {/* Loan Amount in Words */}
          {/*  <div>
          <TextField
            fullWidth
            label="In Words (Loan Amount)"
            name="loanAmountWords"
            value={formDatas.loanAmountWords}
            onChange={handleChange}
          />
          <Button
            variant="outlined"
            size="small"
            sx={{ mt: 1 }}
            disabled={loadingField === "loanAmountWords"}
            onClick={() => handleSave("loanAmountWords")}
          >
            {loadingField === "loanAmountWords" ? "Saving..." : "Save"}
          </Button>
          </div> */}

        {/* Tenor */}
        <div>
          <TextField
            fullWidth
            label={formData.loanrequest.loanCategory === "studentloan" ? "Tenor (1–10 Years)" : "Tenor (1–5 Years)" }
            name="tenor"
            value={formDatas.tenor}
            onChange={handleChange}
            inputProps={{ maxLength: 2, inputMode: "numeric" }}
          />
          <Button
            variant="outlined"
            size="small"
            sx={{ mt: 1 }}
            disabled={loadingField === "tenor"}
            onClick={() => handleSave("tenor")}
          >
          {loadingField === "tenor" ? "Saving..." : "Save"}
          </Button>
        </div>

        {/* Net Monthly Income */}
        <div>
        <NumericFormat
        value={formDatas.netMonthlyIncome}
        onChange={handleChange}
        customInput={TextField}
        thousandSeparator
        label="Net Monthly Income (₦)"
        name="netMonthlyIncome"
        valueIsNumericString
        prefix="₦"
        variant="outlined"
        fullWidth
        inputProps={{ maxLength: 15, inputMode: "numeric" }}
          />

         {/*  <TextField
            fullWidth
            label="Net Monthly Income (₦)"
            name="netMonthlyIncome"
            value={formDatas.netMonthlyIncome.toLocaleString()}
            onChange={handleChange}
            inputProps={{ maxLength: 15, inputMode: "numeric" }}
          /> */}
          <Button
            variant="outlined"
            size="small"
            sx={{ mt: 1 }}
            disabled={loadingField === "netMonthlyIncome"}
            onClick={() => handleSave("netMonthlyIncome")}
          >
            {loadingField === "netMonthlyIncome" ? "Saving..." : "Save"}
          </Button>
        </div>

        {/* Medical student or Non Medical Student */}
        <div>

             <TextField
                  select
                  label="Program Type"
                  name="program_type"
                  value={formDatas.program_type}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  required
                  InputProps={{
                    endAdornment: (
                      <Button variant="outlined" color="secondary" onClick={() => handleSave("program_type")}>
                        Save
                      </Button>
                    ),
                  }}
                  >
                  <MenuItem value="not selected">Select Program Type</MenuItem>
                  <MenuItem value="medical-applicant">Medical Applicant</MenuItem>
                  <MenuItem value="non-medical-applicant">Non-Medical Applicant</MenuItem>
       
                </TextField>
    {/* update loan_requests set program_type = "medical-applicant" where token = "7tKJJT30laTXN6g190"; */}
        
        </div>
   
      </div>

      {/* Dotted separator */}
      <Divider
        sx={{
          my: 4,
          borderStyle: "dotted",
          borderColor: "#ccc",
        }}
      />
    </div>
  );
};

export default LoanRequestInfo;
